// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"WidgetConfiguration_fieldset__w1FOt"};